var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fight-room-item flex flex-center-1" }, [
    _c("div", { staticClass: "listItem flex flex-center-1" }, [
      _vm._v(
        " " +
          _vm._s(_vm._f("addZero")(_vm.multiplePeopleCase_list_item.id)) +
          " "
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "gun-list flex flex-ver",
        class: {
          gunListPCWidth: _vm.currentTab == "mine",
          gunListPCWidth1: _vm.currentTab != "mine",
        },
      },
      _vm._l(_vm.curCases, function (room_case, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "img-con flex flex-col flex-center-1",
            on: {
              click: function ($event) {
                return _vm.openCaseDetail(room_case)
              },
            },
          },
          [
            _c("div", { staticClass: "box-img" }, [
              _c("img", { attrs: { src: _vm.$imgfilter(room_case.picture) } }),
            ]),
            _c("p", { staticClass: "name" }, [_vm._v(_vm._s(room_case.name))]),
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "listItem flex flex-col flex-center-1" }, [
      _c(
        "div",
        { staticClass: "status flex flex-center-1" },
        [
          _vm.multiplePeopleCase_list_item.status == "0"
            ? [
                _c("el-statistic", {
                  staticClass: "countDown",
                  attrs: {
                    format: "HH:mm:ss",
                    "value-style": { fontSize: "16px", color: "#f5b844" },
                    value: _vm.multiplePeopleCase_list_item.endTime,
                    "time-indices": "",
                  },
                }),
              ]
            : [
                _c(
                  "div",
                  {
                    class: [
                      {
                        finished:
                          _vm.multiplePeopleCase_list_item.status == "1" ||
                          _vm.multiplePeopleCase_list_item.status == "4",
                      },
                      {
                        timeout: _vm.multiplePeopleCase_list_item.status == "2",
                      },
                      {
                        canceled:
                          _vm.multiplePeopleCase_list_item.status == "3",
                      },
                    ],
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          ["已创建", "已打开", "未达标", "已取消", "打开中"][
                            _vm.multiplePeopleCase_list_item.status
                          ]
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "listItem-1 flex flex-center-1" }, [
      _c("div", { staticClass: "round" }, [
        _c("p", [
          _vm._v(
            " " +
              _vm._s(_vm.multiplePeopleCase_list_item.currAmount) +
              " / " +
              _vm._s(_vm.multiplePeopleCase_list_item.price) +
              " "
          ),
        ]),
      ]),
    ]),
    _vm.currentTab == "mine"
      ? _c("div", { staticClass: "listItem flex flex-center-1" }, [
          _c("div", { staticClass: "round flex flex-col flex-center-1" }, [
            _vm.multiplePeopleCase_list_item.joinPrice && _vm.$screen.mobile
              ? _c("p", { staticStyle: { "margin-bottom": "4px" } }, [
                  _vm._v(" 我的份額 "),
                ])
              : _vm._e(),
            _vm.multiplePeopleCase_list_item.joinPrice
              ? _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.multiplePeopleCase_list_item.joinPrice) +
                      " "
                  ),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "submit-item flex flex-center-1" }, [
      _c(
        "div",
        {
          staticClass: "btn flex flex-center-1",
          class: [
            { "btn-start": _vm.multiplePeopleCase_list_item.status == "0" },
            {
              "btn-finished":
                _vm.multiplePeopleCase_list_item.status == "1" ||
                _vm.multiplePeopleCase_list_item.status == "4",
            },
            { "btn-timeout": _vm.multiplePeopleCase_list_item.status == "2" },
            { "btn-canceled": _vm.multiplePeopleCase_list_item.status == "3" },
          ],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleShowmultiplePeopleCaseDetail(
                _vm.multiplePeopleCase_list_item
              )
            },
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.multiplePeopleCase_list_item.status == "0"
                  ? "进入"
                  : _vm.multiplePeopleCase_list_item.status == "1"
                  ? "已打开"
                  : _vm.multiplePeopleCase_list_item.status == "4"
                  ? "打开中"
                  : "查看"
              ) +
              " "
          ),
        ]
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "listItem flex flex-center-1 endTimeShow",
        staticStyle: { border: "none" },
      },
      [_vm._v(" " + _vm._s(_vm.multiplePeopleCase_list_item.endTimeShow) + " ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }